import React, { useState, useEffect } from "react";
import axios from "axios";
import GetDistricts from "../../Dropdowns/getDistricts";

axios.defaults.withCredentials = true;

const API_URL_FPS = process.env.REACT_APP_URL_HEADER;
const API_URL = process.env.REACT_APP_URL;

const monthNames = ["", "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

export default function BankApprovalStatusReport() {
  const [state, setState] = useState({
    userRole: "",
    distCode: "",
    districtName: "All Districts",
    currentMonth: null,
    currentYear: null,
    selectedDistrict: "",
    selectedMonth: null,
    selectedYear: null,
    filterStatus: "all",
    records: [],
    loading: false,
    showTable: false
  });

  // Load session + current month/year
  useEffect(() => {
    const init = async () => {
      try {
        const [sessionRes, mRes, yRes] = await Promise.all([
          axios.get(`${API_URL}/api/ekyc-abstract/session-info`),
          axios.get(`${API_URL_FPS}/Common/currentMonth`),
          axios.get(`${API_URL_FPS}/Common/currentYear`)
        ]);

        const role = sessionRes.data.userRole || "";
        const dist = sessionRes.data.distCode || "";
        const curM = mRes.data;
        const curY = yRes.data;

        setState(s => ({
          ...s,
          userRole: role,
          distCode: dist,
          districtName: role === "2" ? (sessionRes.data.userName || dist) : "All Districts",
          currentMonth: curM,
          currentYear: curY,
          selectedMonth: curM,
          selectedYear: curY,
          selectedDistrict: role === "2" ? dist : "",
          filterStatus: "all"
        }));

        if (role === "2") {
          setTimeout(() => handleSubmit(dist, curM, curY, "all"), 50);
        }
      } catch (err) {
        alert("Session expired or failed to load");
      }
    };
    init();
  }, []);


  useEffect(() => {
    if (!state.selectedDistrict || state.userRole === "") return;

    const timer = setTimeout(() => {
      handleSubmit();
    }, 50);

    return () => clearTimeout(timer);
  }, [state.selectedDistrict, state.selectedMonth, state.selectedYear, state.filterStatus, state.userRole]);

  const handleDistrictChange = (code) => {
    const selectElement = document.querySelector('#dist_code');
    const name = selectElement?.options[selectElement.selectedIndex]?.text.trim() || code;

    setState(prev => ({
      ...prev,
      selectedDistrict: code,
      districtName: name
    }));
  };

  const handleSubmit = async () => {
    const district = state.selectedDistrict;
    const month = state.selectedMonth;
    const year = state.selectedYear;
    const status = state.filterStatus;

    if (!district) {
      alert("Please select a District");
      return;
    }

    setState(s => ({ ...s, loading: true, showTable: false }));

    try {
      const res = await axios.get(`${API_URL}/api/fps/bank-approval-status`, {
        params: { district, month, year, filterStatus: status }
      });

      setState(s => ({
        ...s,
        records: res.data || [],
        loading: false,
        showTable: true
      }));
    } catch (err) {
      console.error("API Error:", err);
      alert("Failed to load data: " + (err.response?.data || err.message));
      setState(s => ({ ...s, loading: false, showTable: false }));
    }
  };

  const filteredRecords = state.records.filter(r => {
    if (state.filterStatus === "all") return true;
    const map = { pending: "Pending", approved: "Approved", rejected: "Rejected" };
    return r.status === map[state.filterStatus];
  });

  const exportToExcel = () => {
    const table = document.getElementById("statusTable");
    if (!table) return;

    const uri = 'data:application/vnd.ms-excel;base64,';

    const template = `
  <html xmlns:o="urn:schemas-microsoft-com:office:office" 
        xmlns:x="urn:schemas-microsoft-com:office:excel">
  <head>
    <meta charset="UTF-8">
    <style>
      table, th, td {
        border: 1px solid #000;
        border-collapse: collapse;
      }
      th {
        background-color: #f2f2f2;
        font-weight: bold;
      }
      td, th {
        padding: 4px;
      }
    </style>
  </head>
  <body>
    <table>{table}</table>
  </body>
  </html>`;

    const base64 = s => window.btoa(unescape(encodeURIComponent(s)));
    const format = (s, c) => s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const ctx = { table: table.innerHTML };

    const link = document.createElement('a');
    link.href = uri + base64(format(template, ctx));
    link.download = `Bank_Approval_Status_${state.districtName}_${monthNames[state.selectedMonth]}_${state.selectedYear}.xls`;
    link.click();
  };


  const years = [];
  for (let y = state.currentYear || new Date().getFullYear(); y >= (state.currentYear || 2020) - 5; y--) {
    years.push(y);
  }

  return (
    <>
      <table width="50%" align="center" cellPadding="8" cellSpacing="0" style={{ marginTop: "20px", border: "1px solid #000", fontFamily: "Arial" }}>

        <tbody>
          <tr class="tableheader">
            <th colSpan="10" >
              Bank Details Approval Status Report
            </th>
          </tr>
          <tr >
            <td><strong>District:</strong></td>
            <td>
              {state.userRole === "1" || state.userRole === "22" ? (
                <GetDistricts
                  selectedDistrict={state.selectedDistrict}
                  onChange={handleDistrictChange}
                  onDistrictChange={handleDistrictChange}
                  onLoadingChange={() => { }}
                  showAllOption={false}
                />

              ) : (
                <strong style={{ fontSize: "17px" }}>{state.districtName}</strong>
              )}
            </td>

            <td><strong>Month:</strong></td>
            <td>
              <select
                value={state.selectedMonth || ""}
                onChange={e => setState(s => ({ ...s, selectedMonth: +e.target.value }))}

              >
                {monthNames.map((name, i) => i > 0 && (
                  <option key={i} value={i}>{name}</option>
                ))}
              </select>
            </td>

            <td><strong>Year:</strong></td>
            <td>
              <select
                value={state.selectedYear || ""}
                onChange={e => setState(s => ({ ...s, selectedYear: +e.target.value }))}

              >
                {years.map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </td>

            <td><strong>Status:</strong></td>
            <td>
              <select
                value={state.filterStatus}
                onChange={e => setState(s => ({ ...s, filterStatus: e.target.value }))}

              >
                <option value="all">All</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>
            </td>

            <td>
              <button
                onClick={handleSubmit}
                disabled={state.loading}
                class="button button2"
              >
                {state.loading ? "Loading..." : "submit"}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <br />

      {state.showTable && (
        <>

          <table id="statusTable" width="95%" align="center"
          >
            <thead>
              <tr class="tableheader">
                <th colSpan="12">
                  Bank Details Approval Status - {state.districtName}<br />
                  <small>{monthNames[state.selectedMonth]} {state.selectedYear} [{state.filterStatus.toUpperCase()}]</small>
                </th>
              </tr>
              <tr class="tableheader">
                <th>S.No</th><th>District</th><th>Office / Mandal</th><th>Shop No.</th>
                <th>Dealer Name</th><th>Bank Name</th><th>Branch</th>
                <th>IFSC</th><th>PAN</th><th>A/c No</th><th>Status</th><th>Time</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.length === 0 ? (
                <tr><td colSpan="12">
                  No records found
                </td></tr>
              ) : (
                filteredRecords.map((r, i) => (
                  <tr key={i} >
                    <td>{i + 1}</td>
                    <td>{r.distName || "NA"}</td>
                    <td>{r.afsoName || "NA"}</td>
                    <td>{r.fpsId}</td>
                    <td>{r.dealerName || "NA"}</td>
                    <td>{r.bankName || "NA"}</td>
                    <td>{r.branchName || "NA"}</td>
                    <td>{r.ifscCode || "NA"}</td>
                    <td>{r.panNo || "NA"}</td>
                    <td>{r.acNo || "NA"}</td>
                    <td style={{
                      fontWeight: "bold",
                      color: r.status === "Approved" ? "black" : r.status === "Rejected" ? "black" : "black"
                    }}>
                      {r.status || "Pending"}
                    </td>
                    <td>{r.time || "NA"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

             <br/><br/>
          <div style={{ textAlign: "center",height: "100px", margin: "30px 0" }}>
            <button onClick={exportToExcel} className="button button2"
            >
              Download Excel
            </button>
          </div>
        </>
      )}
    </>
  );
}